<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('positionLevel.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('positionLevel.nameKh') }}
              </label>
              <input type="text" class="form-control" v-model="model.position_level_name_kh" />
              <div class="invalid-feedback" v-if="errors.has('position_level_name_kh')">
                {{ errors.first('position_level_name_kh') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('positionLevel.nameEn') }}
              </label>
              <input type="text" class="form-control" v-model="model.position_level_name_en" />
              <div class="invalid-feedback" v-if="errors.has('position_level_name_en')">
                {{ errors.first('position_level_name_en') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('positionLevel.order') }}
              </label>
              <input type="number" class="form-control" v-model.number="model.level_order" />
              <div class="invalid-feedback" v-if="errors.has('level_order')">
                {{ errors.first('level_order') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">
              {{ $t('button.cancel') }}
            </ts-button>
            ​<ts-button
              outline
              color="primary"
              class="ml-2 primary"
              :waiting="savingAddNew"
              @click.prevent="saveAddNew"
              v-if="editData === undefined"
              >{{ $t('button.saveAddNew') }}</ts-button
            >
            ​<ts-button
              class="btn-primary ml-2"
              :waiting="saving"
              @click.prevent="store"
              v-if="editData === undefined"
              >{{ $t('button.save') }}</ts-button
            >
            ​<ts-button class="btn-primary ml-2" :waiting="saving" @click.prevent="update" v-if="editData">{{
              $t('button.update')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'positionLevel',
  props: ['editData'],
  data() {
    return {
      model: {
        position_level_id: '',
        position_level_name_kh: '',
        position_level_name_en: '',
        level_order: ''
      },
      errors: new Errors(),
      saving: false,
      savingAddNew: false
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/positionLevel/update', {
          id: this.editData.position_level_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/positionLevel/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.savingAddNew = true
      this.$store
        .dispatch('hr/positionLevel/store', this.model)
        .then(response => {
          this.savingAddNew = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.clearInput()
        })
        .catch(error => {
          this.savingAddNew = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    fetchData() {
      this.$store.dispatch('hr/positionLevel/fetch').catch(error => {
        this.$toasted.error(error.message)
      })
    },
    setEditData() {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          position_level_id: this.editData.position_level_id,
          position_level_name_kh: this.editData.position_level_name_kh,
          position_level_name_en: this.editData.position_level_name_en,
          level_order: this.editData.level_order
        }
      }
    },
    clearInput() {
      this.model = {
        position_level_id: '',
        position_level_name_kh: '',
        position_level_name_en: '',
        level_order: ''
      }
    }
  }
}
</script>
